// extracted by mini-css-extract-plugin
module.exports = {"root":"Content_root__V4qNO","center":"Content_center__f_Tal"};